/// <reference path="../objects/interfaces/icustomstate.ts" />
/// <reference path='../providers/blocks.router.provider.ts'/>
/// <reference path='../objects/interfaces/IAppRootScope.ts'/>
/// <reference path="../objects/interfaces/blocks/irouterfactory.ts" />

module Blocks {

    export class RouterFactory implements Blocks.Interfaces.IRouterFactory {
        static factoryId: string = 'routehelper';

        constructor(private $location,
                    private $rootScope: App.Interfaces.IAppRootScope,
                    private $state: angular.ui.IStateService,
                    private routehelperProvider: Blocks.IRouterHelperProvider) {

            this.$stateProvider = routehelperProvider.config.$stateProvider;

            this.handleRoutingErrors();
            this.updateDocTitle();

            $rootScope.$on('$locationChangeStart', (event, next, current) => {
                if ($rootScope.form && $rootScope.form.$invalid) {
                    event.preventDefault();
                }
            });
        }

        $stateProvider: angular.ui.IStateProvider = null;

        $get = () => {
            return this;
        }

        currentState: App.Interfaces.ICustomState = <App.Interfaces.ICustomState>(this.$state.current);
        states: App.Interfaces.ICustomState[] = [];

        handlingRouteChangeError = false;
        routeCounts = {
            errors: 0,
            changes: 0
        };
        

        handleRoutingErrors = () => {
            this.$rootScope.$on('$routeChangeError',
                (event, current, previous, rejection) => {
                    if (this.handlingRouteChangeError) {
                        return;
                    }
                    this.routeCounts.errors++;
                    this.handlingRouteChangeError = true;
                    var destination = (current && (current.title || current.name || current.loadedTemplateUrl)) ||
                        'unknown target';
                    this.$location.path('/');
                }
            );
        }

        updateDocTitle = () => {
            this.$rootScope.$on('$stateChangeSuccess',
                (event, current, previous) => {
                    this.routeCounts.changes++;
                    this.handlingRouteChangeError = false;
                    var title = current.title || '';
                    this.$rootScope.title = title; // data bind to <title>
                    this.currentState = current;
                }
            );
        }

        configureRoutes = (routes: App.Interfaces.ICustomState[]) => {
            routes.forEach((route: App.Interfaces.ICustomState) => {
                this.$stateProvider.state(route);
            });
            this.setRoutes();
        }

        setRoutes = () => {
            this.states = (<App.Interfaces.ICustomState[]>(
                this.$state.get().filter((item) => {
                    return item.hasOwnProperty('title') && !item.abstract;
                }).sort((i1, i2) => {
                    return i1['order'] - i2['order'];
                    })));
        }

        setPipelineRoutes = (steps: string[]) => {
            this.states = (<App.Interfaces.ICustomState[]>(
                this.$state.get().filter((item: App.Interfaces.ICustomState) => {
                    return item.hasOwnProperty('title') && !item.abstract && this.stepIsInStateList(item.configuratorStepName, steps);
                }).sort((i1, i2) => {
                    return i1['order'] - i2['order'];
                    })));
        }

        stepIsInStateList = (configuratorStepNames: string[], states: string[]) => {
            for (var i = 0; i < configuratorStepNames.length; i++) {
                if (states.indexOf(configuratorStepNames[i]) > -1)
                    return true;
            }

            return false;
        }
    }

    router.factory(RouterFactory.factoryId, ['$location', '$rootScope', '$state', Blocks.RouterHelperProvider.providerId, ($location, $rootScope, $state, routehelperProvider) =>
        new RouterFactory($location, $rootScope, $state, routehelperProvider)
    ]);
}